import React from "react";
import { TELEGRAM_SUBSCRIPTION_STATUS_MAP } from "./TelegramSubscriptionStatus.constants";

export const TelegramSubscriptionStatus = ({ status }) => {
  const { className, title } = TELEGRAM_SUBSCRIPTION_STATUS_MAP[status];
  return <span className={className}>{title}</span>;
};
